import { useDateFormatter, useTranslator } from '@bluebeam/react-i18n';
import Button from 'components/Button';
import Permissions from 'components/hoc/Permissions';
import { StdListCell, StdListRow } from 'components/StdList';
import React, { FC } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ProcessingStatus } from 'records/ProcessingStatus';
import camelCase from 'lodash/camelCase';

interface Props extends RouteComponentProps {
  processingStatus: ProcessingStatus;
  style?: React.CSSProperties;
}

const UploadsListRow: FC<Props> = ({
  style,
  history,
  location,
  processingStatus,
}) => {
  const { format } = useDateFormatter({
    dateStyle: 'long',
    timeStyle: 'short',
  });

  const { translate } = useTranslator(['uploadListRow']);
  const statusKey: `${string}:${string}` = `uploadListRow:status.${camelCase(
    processingStatus.status
  )}` as `${string}:${string}`;
  const uploadStatus = translate(statusKey);

  const handleReviewClick = (): void => {
    history.push(
      `${location.pathname}/${processingStatus.processingRequestid}/audit`
    );
  };
  const date = new Date(processingStatus.uploadTimestamp * 1000);
  const rowId = `uploads-list-row-${processingStatus.processingRequestid}`;
  const errorString = `ERRORS: \r\n   ${processingStatus.failedDocuments
    .map(
      (fd) =>
        `DocID: ${fd.documentid}\r\n   Error: ${fd.errorCode}\r\n   Stage: ${fd.errorStage}`
    )
    .join('\r\n\r\n')}`;

  return (
    <StdListRow id={rowId} style={style} noHover>
      <StdListCell id={`${rowId}-cell-uploadtime`}>
        {processingStatus.uploadTimestamp > 0 ? format(date) : ''}
      </StdListCell>
      <StdListCell id={`${rowId}-cell-uploadedby`}>
        {processingStatus.uploadedBy}
      </StdListCell>
      <StdListCell id={`${rowId}-cell-pagecount`}>
        {processingStatus.uploadTimestamp > 0
          ? processingStatus.pagesCount
          : ''}
      </StdListCell>
      <StdListCell id={`${rowId}-cell-status`}>
        <Permissions permissions={['publishDrawings']}>
          {({ hasPerms }): React.ReactNode => {
            return hasPerms &&
              processingStatus.status === 'Ready for Review' ? (
              <Button
                className="ready-for-review-btn my2"
                id={`${rowId}-rfr-btn`}
                onClick={handleReviewClick}
                variant="secondary"
              >
                {translate('uploadListRow:readyForReview')}
              </Button>
            ) : (
              <div title={errorString}>{uploadStatus}</div>
            );
          }}
        </Permissions>
      </StdListCell>
    </StdListRow>
  );
};

export default withRouter(UploadsListRow);
